// The guide's visual language, shared by every toast that sits in its slot
// (GuideToast, the persona question, the upgrade reminder) so they read as one
// family. Buttons inside .project-notes-scope are `all: unset`, so every visual
// property is explicit.

// Three text styles (title, body, meta), weights 400/500.
export const TITLE_TEXT = 'tw-text-[17px] tw-font-medium tw-leading-snug'
export const BODY_TEXT = 'tw-text-sm tw-leading-relaxed'
export const META_TEXT = 'tw-text-[12.5px] tw-leading-snug'
// A step lighter than the body, still ~7:1; the theme's muted-foreground is too faint for a sentence.
export const SECONDARY_TEXT = 'tw-text-[#525252] dark:tw-text-[#b3b3b3]'

// Above the Project Notes dialog (z 120000) so the guide stays readable while the notes are open.
export const TOAST_Z_INDEX = 120010
export const TOAST_MENU_Z_INDEX = TOAST_Z_INDEX + 10

export const ACCENT_TEXT = 'tw-text-[#0089e0] dark:tw-text-[#00b7ff]'
export const AI_ACCENT_TEXT = 'tw-text-[#5063b5] dark:tw-text-[#b7c5ff]'
// The one coloured surface in the body.
export const ACCENT_TINT = 'tw-bg-[#0089e0]/10 dark:tw-bg-[#00b7ff]/10'
export const AI_ACCENT_TINT = 'tw-bg-[#5063b5]/10 dark:tw-bg-[#b7c5ff]/10'
export const DONE_TEXT = 'tw-text-[#15734d] dark:tw-text-[#33c686]'
export const ACCENT_DOT = 'tw-bg-[#0089e0] dark:tw-bg-[#00b7ff]'
export const AI_TONE_BORDER =
    'tw-border-[#5063b5]/50 dark:tw-border-[#b7c5ff]/50'

export const BUTTON_BASE =
    'tw-inline-flex tw-cursor-pointer tw-items-center tw-rounded-full tw-border tw-border-solid tw-px-4 tw-py-2 tw-text-[13px] tw-font-medium tw-transition-colors disabled:tw-cursor-default disabled:tw-opacity-50'
export const ACTION_BUTTON = `${BUTTON_BASE} tw-border-[#0089e0] tw-bg-transparent ${ACCENT_TEXT} hover:tw-bg-[#0089e0]/10 dark:tw-border-[#00b7ff] dark:hover:tw-bg-[#00b7ff]/10`
export const AI_ACTION_BUTTON = `${BUTTON_BASE} tw-border-[#5063b5] tw-bg-transparent ${AI_ACCENT_TEXT} hover:tw-bg-[#5063b5]/10 dark:tw-border-[#b7c5ff] dark:hover:tw-bg-[#b7c5ff]/10`
// Solid fill: the one call to action that should outweigh everything else in the card.
export const PRIMARY_BUTTON = `${BUTTON_BASE} tw-border-[#15734d] tw-bg-[#15734d] tw-text-white hover:tw-border-[#105c3d] hover:tw-bg-[#105c3d] dark:tw-border-[#33c686] dark:tw-bg-[#33c686] dark:tw-text-[#0b2a1d] dark:hover:tw-border-[#5ad49d] dark:hover:tw-bg-[#5ad49d]`
export const GHOST_BUTTON = `${BUTTON_BASE} tw-border-transparent tw-bg-transparent tw-text-muted-foreground hover:tw-bg-muted hover:tw-text-foreground`

// The closing row under the content: context on the left, buttons on the right.
export const TOAST_FOOTER =
    'tw-mt-4 tw-flex tw-gap-3 tw-border-0 tw-border-t tw-border-solid tw-border-border tw-pt-3'

export const ICON_BUTTON =
    'tw-flex tw-h-7 tw-w-7 tw-shrink-0 tw-cursor-pointer tw-items-center tw-justify-center tw-rounded-full tw-text-muted-foreground tw-transition-colors hover:tw-bg-muted hover:tw-text-foreground'

// One of several: the selected choice takes the accent outline. Tabs are the
// compact size (MCP client picker), chips the button size (persona options).
const CHOICE_SELECTED = `tw-border-[#0089e0] dark:tw-border-[#00b7ff] ${ACCENT_TEXT}`
const CHOICE_IDLE =
    'tw-border-border tw-text-muted-foreground hover:tw-text-foreground'
const CHOICE_TAB_BASE =
    'tw-cursor-pointer tw-rounded-full tw-border tw-border-solid tw-px-2.5 tw-py-1 tw-text-xs tw-transition-colors'

export const choiceTabClass = selected =>
    `${CHOICE_TAB_BASE} ${selected ? CHOICE_SELECTED : CHOICE_IDLE}`

export const choiceChipClass = selected =>
    `${BUTTON_BASE} tw-bg-transparent ${
        selected ? `${CHOICE_SELECTED} ${ACCENT_TINT}` : CHOICE_IDLE
    }`
